import { createClient } from '@supabase/supabase-js';

// Browser client — uses the public anon key only. No service-role key or other
// secret is ever referenced in frontend code.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://uvxgbltpknxnmwazcdoo.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_fbGeFy4-tRc1XuMHhBuk7A_raijRc53';

// Exported so a best-effort tab-close hold release can hit the edge function via
// fetch(keepalive)/sendBeacon, which can't go through the supabase-js client.
export { supabaseUrl, supabaseAnonKey };

// This client is NOT an auth client — the customer flow uses it only for anon
// data reads and functions.invoke, never supabase.auth. Explicitly disable URL
// session detection and persistence so it can never grab the partner's
// verification tokens from the URL (which would race the partner client below).
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
});

// Second, fully isolated client for the partner portal (travel agencies).
// This one DOES use Supabase Auth (email + password). The custom storageKey
// keeps its session in its own localStorage slot so it can never collide with
// anything the anon `supabase` client above does for the customer OTP flow.
// The customer flow must never touch this client, and this client must never be
// used for the customer flow.
export const supabasePartner = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'alfresco-partner-auth',
    persistSession: true,
    autoRefreshToken: true,
    // This client EXPLICITLY owns the email-verification redirect. It is the only
    // client that should detect and process auth tokens from the URL.
    detectSessionInUrl: true,
  },
});
